import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StackDivider, Text, VStack } from '@chakra-ui/react';
import type { AccountPaymentsGetContractDetailsResponse } from '@netiva/classifieds-api';

import { PriceSummary } from '@/components/ui';
import { useDate } from '@/hooks';

export type ContractDetailsProps = {
  contract: AccountPaymentsGetContractDetailsResponse;
};

export const ContractDetails: FC<ContractDetailsProps> = ({ contract }) => {
  const { t } = useTranslation();
  const { formatDate } = useDate();

  const payBefore = formatDate(contract.payBefore, true);
  const message = payBefore
    ? contract.requiresPrepayment
      ? t('payment.message.withDate.requiresPrepayment', { date: payBefore })
      : t('payment.message.withDate', { date: payBefore })
    : contract.requiresPrepayment
      ? t('payment.message.withoutDate.requiresPrepayment')
      : t('payment.message.withoutDate');

  return (
    <VStack align="stretch" divider={<StackDivider />} spacing={4}>
      <div>
        <Text dangerouslySetInnerHTML={{ __html: message }} />
      </div>
      <PriceSummary
        productId={contract.product.id}
        extensionProductIds={contract.extensionProducts.map((ext) => ext.id)}
        billingAddressId={contract.billingAddressId}
        maxWidth="500px"
      />
    </VStack>
  );
};
